var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up-loading 1",
    clipPath: "url(#clip0_458_1978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000097469747894302416050000002917915783155835571_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.98799 11.9984C5.01299 11.9984 4.03799 11.9984 3.06533 11.9984C1.72939 11.9961 0.766113 11.0375 0.759082 9.70155C0.756738 9.23515 0.756738 8.76874 0.759082 8.30233C0.761426 7.82186 1.05205 7.51249 1.49971 7.51015C1.94736 7.5078 2.24033 7.81718 2.24502 8.29765C2.24736 8.77108 2.24268 9.24686 2.24736 9.72264C2.25205 10.2195 2.54268 10.5101 3.04424 10.5101H8.96689C9.46611 10.5101 9.75908 10.2195 9.76377 9.72264C9.76611 9.24921 9.76143 8.77343 9.76611 8.29765C9.76846 7.81718 10.0614 7.51015 10.5091 7.51015C10.9567 7.51015 11.2521 7.81952 11.2474 8.30233C11.2427 8.90936 11.2755 9.52343 11.2005 10.1211C11.0599 11.218 10.1271 11.9914 9.01611 11.9961C8.00361 12.0031 6.9958 11.9984 5.98799 11.9984Z",
    fill: "#1253FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.25693 2.56014C5.14443 2.66561 5.07647 2.72421 5.01553 2.78514C4.53975 3.26561 4.06865 3.74843 3.59053 4.22421C3.25068 4.56405 2.77959 4.58749 2.4749 4.29218C2.17022 3.99686 2.18193 3.50936 2.51475 3.17186C3.48506 2.19686 4.45772 1.22421 5.43272 0.253894C5.77725 -0.0882934 6.2249 -0.0882934 6.56709 0.253894C7.54912 1.22889 8.52647 2.20624 9.50147 3.18827C9.82256 3.51171 9.8249 3.99921 9.5249 4.28983C9.2249 4.58046 8.75147 4.56639 8.42568 4.24296C7.94053 3.76014 7.46475 3.2703 6.98428 2.78514C6.92334 2.72186 6.85537 2.66327 6.75693 2.57186C6.7499 2.70546 6.74287 2.79218 6.74287 2.88124C6.74287 4.41405 6.74522 5.94921 6.74053 7.48202C6.73818 8.05858 6.23428 8.40077 5.70693 8.19452C5.41631 8.08202 5.25693 7.82889 5.25693 7.45858C5.25459 5.94218 5.25459 4.42577 5.25693 2.90702V2.56014Z",
    fill: "#1253FA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_1978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLoading);
export default __webpack_public_path__ + "static/media/up-loading.34013d9fc09df825e22195bc9bc3d86f.svg";
export { ForwardRef as ReactComponent };